import Layout from "../Components/Layout"
import ContactComp from "../Components/ContactComp"
const Contact=()=>{
    return(
        <>
        <Layout>
          <ContactComp/>
        </Layout>
        </>
    )
}
export default Contact